import { cn } from "@/lib/utils";

export const BentoGrid = ({
	className,
	children,
}: {
	className?: string;
	children?: React.ReactNode;
}) => {
	return (
		<div
			className={cn(
				"max-w-7xl gap-4",
				"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
				// "auto-rows-[8rem] lg:auto-rows-[12rem] ",
				"lg:auto-rows-[minmax(12rem,auto)]",
				className,
			)}
		>
			{children}
		</div>
	);
};
